import React, { useEffect, useState } from 'react'
import { Box, Typography, Button, Drawer, IconButton, InputLabel, FormControl, Select, MenuItem, TextField, FormHelperText, Dialog, DialogContent, ToggleButtonGroup, ToggleButton, FormControlLabel, Switch } from '@mui/material'

import { toast } from 'react-toastify';
import { ApiGetFixitList, ApiUpdateFixit } from '../../apiService/Core/Apicall';
import { RootState } from '../../global/config/store';
import { useSelector } from 'react-redux';
import storage from '../../utils/storage';



function FixIt() {
    const [refresh, setrefresh] = useState<boolean>(false)
    const userData = JSON.parse(storage.getItem("userData") || "{}");
    const [fixitlist, setfixitlist] = useState<any[]>([])
    // const dispatch = useDispatch()
    const [selectedId, setselectedId] = useState<any>(0)
    const [alignment, setAlignment] = React.useState('opn');
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)



    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        newAlignment && setAlignment(newAlignment);
    };



    useEffect(() => {
        const fixitlist = async () => {
            const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&fixItStatusCode=${alignment}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

            try {
                const response = await ApiGetFixitList(data)
                setfixitlist(response.data.data)
            }
            catch (error: any) {
                // toast.error(error)
                console.log("Error", error)
            }

        }
        fixitlist()
    }, [refresh, alignment, clientEntity, isGroupScore])


    const handlUpdateFixIt = async (fixitId: number, status: number) => {

        try {
            const data = {
                fixItId: fixitId,
                fixItStatusId: status
            }
            const res = await ApiUpdateFixit(data)
            if (res.status) {
                setrefresh(!refresh)
            }
        } catch (error) {
            console.log("Error", error)
        }
    }
    return (
        <Box className='w-100 pt-0' height='calc(100vh - 100px)'>
            {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                <Box className='w-100 d-flex justify-content-end'>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isGroupScore}
                                onChange={(e) => setisGroupScore(e.target.checked)}
                            />
                        }
                        label={"Whole Group"}
                    />
                </Box>)}
            <Box className='w-100 d-flex'>
                <Box className="col-4 pt-0 h-100" sx={{ borderRight: '1px solid #a0a0a0' }}>
                    <Box className="selected  togglebutton  d-flex justify-content-center mb-0">
                        <ToggleButtonGroup
                            className="d-flex justify-content-center col-6 m-0 p-0 mx-auto"
                            exclusive
                            value={alignment}
                            onChange={handleChange}
                        >
                            <ToggleButton className="py-2 col-4 m-0" value="opn">
                                Open
                            </ToggleButton>
                            <ToggleButton className="py-2 col-4 m-0" value="don">
                                Closed
                            </ToggleButton>
                            <ToggleButton className="py-2 col-4 m-0" value="can">
                                Cancelled
                            </ToggleButton>

                        </ToggleButtonGroup>
                    </Box>
                    <Box className='mt-2' overflow='auto' height='calc(100vh - 180px)'>
                        {fixitlist?.length > 0 ? (fixitlist?.map((item, index) => (
                            <Box className='pe-3  py-2' maxHeight='calc(100vh - 140px)' overflow='auto' onClick={() => { setselectedId(index) }}>
                                <Box mb={2} sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} className={`d-flex align-items-stretch p-2 ${selectedId === index ? 'bg-main' : ""}`} gap={2}>
                                    <Box sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} src={item.images[0]} component='img' alt='img' height='125px' width='150px'></Box>
                                    <Box className='ms-2'>
                                        <Typography color='#a0a0a0' bgcolor='#0000001A' borderRadius='5px' py='5px' px={2} className='mb-5' sx={{ color: selectedId === index ? '#FFFFFF' : '' }} variant='caption'>{item.fixItStatusDesc}</Typography>
                                        <Typography variant='body2' className='fw-bold mt-2' sx={{ color: selectedId === index ? '#FFFFFF' : '' }}>{item.title}</Typography>
                                        <Typography variant='body2' sx={{
                                            color: selectedId === index ? '#FFFFFF' : '', display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}>{item.description}</Typography>
                                        <Typography variant='caption' sx={{ color: selectedId === index ? '#FFFFFF' : '' }}><span className='fw-bold'>Location:</span>{item.area}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ))) : <Typography className='mx-auto text-center my-5' variant='h5'>There are currently no Fix-It reports requiring your attention.</Typography>}
                    </Box>
                </Box>

                <Box className="col-8 p-4 pb-2 d-flex flex-column">
                    {selectedId !== null && fixitlist[selectedId] && (
                        <>
                            <Box className='flex-1'>
                                <Typography color='#a0a0a0' bgcolor='#0000001A' borderRadius='5px' py='5px' px={2} className='mb-5' variant='caption'>{fixitlist[selectedId].fixItStatusDesc}</Typography>
                                <Box className='d-flex my-2 align-items-center justify-content-between'>
                                    <Typography variant='h6' className='fw-bold mt-2'>{fixitlist[selectedId].title}</Typography>
                                    <Typography variant="body2">
                                        <span className="fw-bold">Added on:</span>{' '}
                                        {new Date(fixitlist[selectedId].createdOn).toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        }).replace(',', ' |')}
                                    </Typography>
                                </Box>
                                <Box mb={2} className='d-flex align-items-start' gap={1}>
                                    <Box className='col-8 p-0' sx={{ borderRadius: '10px', border: '1px solid #a0a0a0', objectFit: 'cover' }} src={fixitlist[selectedId].images[0]} component='img' alt='img' maxHeight='300px'></Box>
                                    <Box className='p-0 col-4 d-flex flex-wrap justify-content-between align-items-center'>
                                        {fixitlist && fixitlist[selectedId].images.map((item: any, index: number) => (
                                            index !== 0 && (<Box className='p-0 w-49' key={index} sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} src={item} component='img' height='150px' alt='img'></Box>)
                                        ))}
                                    </Box>
                                </Box>
                                <Typography variant='body1' className='mb-2'><span className='fw-bold'>Location:</span>{fixitlist[selectedId].area}</Typography>
                                <Typography variant='body1'>
                                    {fixitlist[selectedId].description}
                                </Typography>
                            </Box>
                            <Box height='fit-content' className='px-2 mt-auto pb-0 pt-3 d-flex apign-items-center justify-content-between' sx={{ borderTop: '1px solid #a0a0a0' }}>
                                {/* <Button className='button-primary-outlined py-2 px-4' onClick={() => { setOpenDialog(true) }} variant='outlined'>Cancel Request</Button> */}
                                {alignment !== 'can' && (<Button className='button-primary-outlined py-2 px-4' variant='outlined' onClick={() => { handlUpdateFixIt(fixitlist[selectedId].fixItId, 3) }}>Cancel Request</Button>)}
                                {alignment !== 'don' && (<Button className='button-primary py-2 px-4' onClick={() => { handlUpdateFixIt(fixitlist[selectedId].fixItId, 4) }}>Mark As Done</Button>)}
                            </Box>
                        </>

                    )}
                </Box>
            </Box>







        </Box >


    )
}

export default FixIt
